<template>
  <el-dialog
    :title="isEdit ? '编辑基准线路' : '新建基准线路'"
    :visible.sync="dialogVisible"
    width="1200px"
    top="5vh"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    append-to-body
    class="route-edit-dialog"
    @opened="onDialogOpened"
  >
    <div v-loading="loading" class="edit-body">
      <!-- 顶部基础信息 -->
      <div class="top-info-bar">
        <el-form :model="form" label-width="90px" size="small" inline>
          <el-form-item label="线路名称" required>
            <el-input v-model="form.name" placeholder="请输入线路名称" style="width: 260px;" maxlength="64" />
          </el-form-item>
          <el-form-item label="线路编号">
            <el-input v-model="form.code" placeholder="可选，如RT-XXX" style="width: 180px;" />
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="form.status">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="0">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="metrics">
          <div class="metric">
            <span class="m-label">总里程</span>
            <span class="m-value">{{ form.totalLengthKm || '0.0' }} km</span>
          </div>
          <div class="metric">
            <span class="m-label">顶点数</span>
            <span class="m-value">{{ (form.geom || []).length }} 点</span>
          </div>
          <div class="metric">
            <span class="m-label">原始轨迹</span>
            <span class="m-value">{{ rawTrackPoints.length }} 点</span>
          </div>
        </div>
      </div>

      <!-- 车辆轨迹查询区 -->
      <div class="track-query-bar">
        <el-form :model="trackQuery" label-width="80px" size="small" inline>
          <el-form-item label="来源车辆" required>
            <el-select
              v-model="trackQuery.vehicleId"
              filterable
              placeholder="选择车辆"
              style="width: 220px;"
            >
              <el-option
                v-for="item in vehicleOptions"
                v-if="item.treeLevel == 5"
                :key="item.nodeValue"
                :label="item.name"
                :value="item.nodeValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围" required>
            <el-date-picker
              v-model="trackQuery.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 380px;"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :loading="trackLoading" @click="queryTrack">
              查询轨迹
            </el-button>
            <!-- <el-button icon="el-icon-magic-stick" :disabled="!rawTrackPoints.length" @click="generateRouteFromTrack">
              生成基准线
            </el-button> -->
          </el-form-item>
        </el-form>
        <div v-if="sourceVehiclePlate" class="source-info">
          <i class="el-icon-truck"></i>
          来源车辆：<b>{{ sourceVehiclePlate }}</b>
          <span v-if="sourceTripTime"> · 行驶时间：{{ sourceTripTime }}</span>
        </div>
      </div>

      <div class="main-split">
        <!-- 左侧面板 -->
        <div class="left-panel">
          <!-- 附加点管理 -->
          <div class="panel-section flex-grow">
            <div class="section-title">
              <span>
                <i class="el-icon-place"></i> 附加点
                <span class="badge">{{ (form.extraPoints || []).length }}</span>
              </span>
              <div class="section-actions">
                <el-button size="mini" type="text" :disabled="pickMode !== null" @click="startPickPoint(2)">
                  <i class="el-icon-circle-plus-outline"></i> 地图取豁免点
                </el-button>
                <!-- <el-button size="mini" type="text" :disabled="pickMode !== null" @click="startPickPoint(1)">
                  <i class="el-icon-circle-plus-outline"></i> 地图取途经点
                </el-button> -->
                <el-button size="mini" type="text" @click="cancelPickPoint" v-if="pickMode !== null">
                  <i class="el-icon-close"></i> 取消拾取
                </el-button>
              </div>
            </div>

            <div class="extra-points-list">
              <div v-if="!(form.extraPoints || []).length" class="empty-tip">
                暂无附加点，点击上方按钮在地图上拾取
              </div>
              <div
                v-for="(p, idx) in form.extraPoints"
                :key="idx"
                class="ep-item"
                :class="['ep-type-' + p.pointType]"
              >
                <div class="ep-icon">
                  <i v-if="p.pointType === 2" class="el-icon-location-outline" style="color: #E6A23C;"></i>
                  <i v-else class="el-icon-star-on" style="color: #909399;"></i>
                </div>
                <div class="ep-main">
                  <div class="ep-name">{{ p.name || '未命名点' }}</div>
                  <div class="ep-meta">
                    <span class="ep-type-tag">{{ p.pointType === 2 ? '豁免点' : '途经点' }}</span>
                    <span v-if="p.pointType === 2" class="ep-radius">半径 {{ p.radiusM }}m</span>
                    <span class="ep-coord">{{ fmtCoord(p) }}</span>
                  </div>
                  <el-form size="mini" inline class="ep-form">
                    <el-form-item label="名称">
                      <el-input v-model="p.name" style="width: 160px;" size="mini" @change="redrawExtraPoints" />
                    </el-form-item>
                    <el-form-item v-if="p.pointType === 2" label="半径(m)">
                      <el-input-number v-model="p.radiusM" :min="50" :max="2000" size="mini" style="width: 110px;" @change="redrawExtraPoints" />
                    </el-form-item>
                    <el-form-item label="备注">
                      <el-input v-model="p.remark" size="mini" placeholder="可选" style="width: 180px;" />
                    </el-form-item>
                  </el-form>
                </div>
                <el-button size="mini" type="text" style="color: #F56C6C;" @click="removeExtraPoint(idx)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </div>
            </div>
          </div>

          <!-- 备注 -->
          <div class="panel-section">
            <div class="section-title"><i class="el-icon-document"></i> 备注</div>
            <el-input v-model="form.remark" type="textarea" :rows="2" size="small" placeholder="可选，线路说明" />
          </div>
        </div>

        <!-- 右侧地图 -->
        <div class="right-map">
          <!-- <div class="map-toolbar">
            <el-checkbox v-model="showOriginal" size="mini" @change="drawAll">显示原始轨迹</el-checkbox>
            <el-checkbox v-model="showExtraPoints" size="mini" style="margin-left: 8px;" @change="drawAll">显示附加点</el-checkbox>
            <div style="margin-left: auto;" v-if="pickMode !== null" class="pick-hint">
              <i class="el-icon-aim"></i> 请在地图上点击拾取{{ pickMode === 2 ? '豁免点' : '途经点' }}位置
            </div>
          </div> -->
          <div class="map-container">
            <KingLongMap ref="routeMap" :mapId="'routeEditMap'" @LoadCompleted="onMapLoaded" />
          </div>
          <div class="map-legend">
            <!-- <div class="legend-item"><span class="lg line route-line"></span> 基准线</div> -->
            <div class="legend-item"><span class="lg line original-line"></span> 原始轨迹</div>
            <!-- <div class="legend-item"><span class="lg area buffer-area"></span> 缓冲区</div> -->
            <div class="legend-item"><span class="lg dot exempt-dot"></span> 豁免点</div>
            <!-- <div class="legend-item"><span class="lg dot waypoint-dot"></span> 途经点</div> -->
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" :loading="saving" @click="handleSave">
        {{ form.id ? '保存' : '创建' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import KingLongMap from '@/components/KingLongMap.vue';

export default {
  name: 'RouteEditDialog',
  components: { KingLongMap },
  props: {
    visible: { type: Boolean, default: false },
    routeId: { type: [Number, String], default: null }
  },
  data() {
    return {
      loading: false,
      saving: false,
      form: this.emptyForm(),
      showOriginal: true,
      showExtraPoints: true,
      // 车辆轨迹查询
      trackQuery: { vehicleId: null, timeRange: [] },
      trackLoading: false,
      rawTrackPoints: [],   // 原始GPS轨迹点 [{lng,lat,time,speed},...]
      rawTrackCoords: [],   // 原始轨迹坐标 [{lng,lat},...]
      sourceVehiclePlate: '',
      sourceTripTime: '',
      // 地图
      mapReady: false,
      pickMode: null,       // null | 1(途经点) | 2(豁免点)
    };
  },
  computed: {
    ...mapState({
      vehicles: (state) => state.app.vehicles
    }),
    dialogVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    },
    isEdit() { return !!this.routeId; },
    // 来源车辆下拉：取自全局车辆树数据（treeLevel == 5 为实际车辆）
    vehicleOptions() {
      return (this.vehicles.data || []).filter(item => item.treeLevel == 5);
    }
  },
  watch: {
    visible: {
      immediate: false,
      handler(v) {
        if (v) {
          this.resetForm();
          if (this.routeId) this.loadDetail();
        } else {
          this.pickMode = null;
        }
      }
    }
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        name: '',
        code: '',
        sourceType: 1,
        sourceVehicleId: null,
        sourceVehiclePlate: '',
        sourceTripId: '',
        geom: [],
        pointCount: 0,
        totalLengthM: 0,
        totalLengthKm: '0.0',
        extraPoints: [],
        extraPointCount: 0,
        bindingCount: 0,
        status: 1,
        version: 1,
        remark: ''
      };
    },
    resetForm() {
      this.form = this.emptyForm();
      this.rawTrackPoints = [];
      this.rawTrackCoords = [];
      this.sourceVehiclePlate = '';
      this.sourceTripTime = '';
      this.trackQuery = { vehicleId: null, timeRange: [] };
    },
    loadDetail() {
      this.loading = true;
      this.$api.QueryPLRouteInfoByID({ RouteID: this.routeId }).then(res => {
        this.loading = false;
        if (res.code === 200 && res.data) {
          const d = res.data;
          const form = this.emptyForm();
          form.id = d.RouteID;
          form.name = d.RouteName || '';
          form.code = d.RouteNo || '';
          form.status = d.RouteStatus;
          form.remark = d.Remark || '';
          form.sourceVehicleId = d.VehicleID;
          // 附加点：接口 PointType 8 为豁免点
          form.extraPoints = (d.AddPointData || []).map(p => ({
            id: p.WayPointID || 0,
            routeId: d.RouteID,
            pointType: 2,
            pointTypeText: '豁免点',
            name: p.WayPointName || '',
            category: 'SERVER',
            lng: Number(p.Longitude),
            lat: Number(p.Latitude),
            radiusM: p.RangeRadius || 0,
            seq: p.PointNo || 0,
            remark: p.Remark || ''
          }));
          this.form = form;
          // 回填车辆与时间范围，自动获取轨迹显示线路
          this.trackQuery.vehicleId = d.VehicleID || null;
          this.trackQuery.timeRange = [this.formatServerTime(d.EffStartTime), this.formatServerTime(d.EffEndTime)];
          this.sourceTripTime = this.trackQuery.timeRange[0] + ' ~ ' + this.trackQuery.timeRange[1];
          if (d.VehicleID && this.trackQuery.timeRange[0] && this.trackQuery.timeRange[1]) {
            this.queryTrack();
          } else {
            this.$nextTick(() => this.drawAll());
          }
        }
      }).catch(() => { this.loading = false; });
    },
    // 服务端 ISO 时间("2026-09-07T00:00:00Z")转 "yyyy-MM-dd HH:mm:ss"
    formatServerTime(str) {
      if (!str) return '';
      return String(str).replace('T', ' ').replace(/\.\d+Z$/, '').replace(/Z$/, '').trim();
    },
    onDialogOpened() {
      // 弹窗动画完成后触发地图初始化
      this.$nextTick(() => {
        if (this.$refs.routeMap && !this.$refs.routeMap.map) {
          this.$refs.routeMap.initMap();
        }
      });
    },
    onMapLoaded() {
      this.mapReady = true;
      this.drawAll();
    },
    // 查询车辆历史轨迹
    queryTrack() {
      if (!this.trackQuery.vehicleId) {
        this.$message.warning('请选择来源车辆'); return;
      }
      if (!this.trackQuery.timeRange || this.trackQuery.timeRange.length !== 2) {
        this.$message.warning('请选择查询时间范围'); return;
      }
      this.trackLoading = true;
      const v = this.vehicleOptions.find(x => x.nodeValue === this.trackQuery.vehicleId);
      this.sourceVehiclePlate = v ? v.name : '';
      this.sourceTripTime = this.trackQuery.timeRange[0] + ' ~ ' + this.trackQuery.timeRange[1];

      this.$api.QueryVehicleTrackInfo({
        VehicleId: this.trackQuery.vehicleId.toString(), // "100844"
        StartTime: this.trackQuery.timeRange[0],         // "2026-09-04 00:00:00"
        EndTime: this.trackQuery.timeRange[1],           // "2026-09-04 14:41:16"
        Flag: 2,
        ParkDuration: 1,
        LanguageId: 1
      }).then(res => {
        this.trackLoading = false;
        if (res.code === 200 && res.data) {
          const gpsData = res.data.GpsData || [];
          if (!gpsData.length) {
            this.$message.warning('该时间段内无轨迹数据');
            return;
          }
          this.rawTrackPoints = gpsData.map(g => ({
            lng: g.Longitude,
            lat: g.Latitude,
            time: g.GpsDateTime,
            speed: g.Speed
          }));
          this.rawTrackCoords = this.rawTrackPoints.map(p => ({ lng: p.lng, lat: p.lat }));
          // this.$message.success(`查询到 ${gpsData.length} 个GPS轨迹点`);
          // 自动生成基准线
          this.generateRouteFromTrack();
        }
      }).catch(() => { this.trackLoading = false; });
    },
    // 从原始轨迹生成基准线（抽稀）
    generateRouteFromTrack() {
      if (!this.rawTrackCoords.length) {
        this.$message.warning('请先查询车辆轨迹'); return;
      }
      // Douglas-Peucker 简化（固定容差8米）
      const tolerance = 8;
      const simplified = this.douglasPeucker(this.rawTrackCoords, tolerance);
      this.form.geom = simplified.map(p => [p.lng, p.lat]);
      this.form.sourceVehicleId = this.trackQuery.vehicleId;
      this.form.sourceVehiclePlate = this.sourceVehiclePlate;
      this.form.sourceTripId = 'TRIP_' + Date.now();
      this.recomputeMetrics();
      this.drawAll();
      // this.$message.success(`已生成基准线（${this.form.geom.length} 个顶点）`);
    },
    // Douglas-Peucker 抽稀算法
    douglasPeucker(points, toleranceM) {
      if (points.length <= 2) return points.slice();
      // 容差米转经纬度（近似）
      const lat0 = points.reduce((s, p) => s + p.lat, 0) / points.length;
      const kx = 1 / (111320 * Math.cos(lat0 * Math.PI / 180));
      const ky = 1 / 110540;
      const tol2 = (toleranceM * kx) ** 2 + (toleranceM * ky) ** 2;

      const dp = (pts, lo, hi, out) => {
        if (hi <= lo + 1) return;
        let maxD = 0, maxIdx = lo + 1;
        const a = pts[lo], b = pts[hi];
        for (let i = lo + 1; i < hi; i++) {
          const d = this.perpDist2(pts[i], a, b);
          if (d > maxD) { maxD = d; maxIdx = i; }
        }
        if (maxD > tol2) {
          dp(pts, lo, maxIdx, out);
          dp(pts, maxIdx, hi, out);
        } else {
          // 中间点都不要
        }
      };
      const keep = new Array(points.length).fill(false);
      keep[0] = true; keep[points.length - 1] = true;
      const stack = [[0, points.length - 1]];
      while (stack.length) {
        const [lo, hi] = stack.pop();
        if (hi <= lo + 1) continue;
        let maxD = 0, maxIdx = lo + 1;
        const a = points[lo], b = points[hi];
        for (let i = lo + 1; i < hi; i++) {
          const d = this.perpDist2(points[i], a, b);
          if (d > maxD) { maxD = d; maxIdx = i; }
        }
        if (maxD > tol2) {
          keep[maxIdx] = true;
          stack.push([lo, maxIdx]);
          stack.push([maxIdx, hi]);
        }
      }
      return points.filter((_, i) => keep[i]);
    },
    perpDist2(p, a, b) {
      const dx = b.lng - a.lng, dy = b.lat - a.lat;
      const len2 = dx * dx + dy * dy;
      if (len2 < 1e-12) return (p.lng - a.lng) ** 2 + (p.lat - a.lat) ** 2;
      let t = ((p.lng - a.lng) * dx + (p.lat - a.lat) * dy) / len2;
      t = Math.max(0, Math.min(1, t));
      const px = a.lng + t * dx, py = a.lat + t * dy;
      return (p.lng - px) ** 2 + (p.lat - py) ** 2;
    },
    recomputeMetrics() {
      const g = this.form.geom || [];
      let totalM = 0;
      for (let i = 1; i < g.length; i++) {
        const [lng1, lat1] = g[i - 1];
        const [lng2, lat2] = g[i];
        const centerLat = (lat1 + lat2) / 2 * Math.PI / 180;
        const dx = (lng2 - lng1) * 111320 * Math.cos(centerLat);
        const dy = (lat2 - lat1) * 110540;
        totalM += Math.hypot(dx, dy);
      }
      this.form.totalLengthM = totalM;
      this.form.totalLengthKm = (totalM / 1000).toFixed(1);
      this.form.pointCount = g.length;
    },
    fmtCoord(p) {
      return `${(Number(p.lng) || 0).toFixed(5)}, ${(Number(p.lat) || 0).toFixed(5)}`;
    },
    // ========== 地图绘制 ==========
    drawAll() {
      if (!this.mapReady || !this.$refs.routeMap) return;
      const map = this.$refs.routeMap;
      map.clearAll();

      // 1. 原始轨迹（灰色细线）
      if (this.showOriginal && this.rawTrackCoords.length > 1) {
        map.addPolyline('raw_track', '原始轨迹', this.rawTrackCoords, 3, '#C0C4CC', false, false);
      }

      // 2. 基准线（蓝色粗线）
      const geom = this.form.geom || [];
      if (geom.length > 1) {
        const coords = geom.map(p => ({ lng: p[0], lat: p[1] }));
        map.addPolyline('route_line', '基准线', coords, 5, '#409EFF', false, true);

        // 起终点标记（图标参考 travel_trajectory_map）
        const start = geom[0], end = geom[geom.length - 1];
        map.addMarker('route_start', '起点', start[0], start[1], 'assets/svgs/ic_dingwei_qidian_lv@2x.png', null, 27, 36);
        map.addMarker('route_end', '终点', end[0], end[1], 'assets/svgs/ic_dingwei_zhongdian_hong@2x.png', null, 27, 36);
      }

      // 3. 附加点
      if (this.showExtraPoints) {
        this.redrawExtraPoints();
      }
    },
    redrawExtraPoints() {
      const map = this.$refs.routeMap;
      if (!map) return;
      // 移除旧的附加点标记
      (this.form.extraPoints || []).forEach((p, i) => {
        map.removeMarkerById('ep_' + i);
        map.removeCircleById('ep_circle_' + i);
      });
      if (!this.showExtraPoints) return;

      (this.form.extraPoints || []).forEach((p, i) => {
        const id = 'ep_' + i;
        const cid = 'ep_circle_' + i;
        if (p.pointType === 2) {
          // 豁免点：橙色圆 + 半径圈
          map.addCircle(cid, { lng: p.lng, lat: p.lat }, p.radiusM || 200,
            2, '#E6A23C', 'rgba(230,162,60,0.12)', false);
          map.addMarker(id, p.name || '豁免点', p.lng, p.lat, null, null, 14, 14, { color: '#E6A23C' });
        } else {
          // 途经点：灰色标记
          map.addMarker(id, p.name || '途经点', p.lng, p.lat, null, null, 14, 14, { color: '#909399' });
        }
      });
    },
    // ========== 地图拾取附加点 ==========
    startPickPoint(type) {
      this.pickMode = type;
      const map = this.$refs.routeMap;
      if (!map) return;
      const ok = map.enablePickPoint((lng, lat) => {
        this.addExtraPoint(type, lng, lat);
        // 豁免点拾取一次后继续，途经点也继续，直到用户取消
      }, false); // false = 不自动关闭，连续拾取
      if (!ok) {
        // 底图不支持拾取，降级为手动添加
        this.$message.warning('当前地图不支持拾取，请在左侧手动填写坐标');
        this.addExtraPoint(type);
      }
    },
    cancelPickPoint() {
      this.pickMode = null;
      if (this.$refs.routeMap) this.$refs.routeMap.disablePickPoint();
    },
    addExtraPoint(type, lng, lat) {
      const g = this.form.geom || [];
      if (lng == null || lat == null) {
        const mid = g.length ? g[Math.floor(g.length / 2)] : [116.4, 39.9];
        lng = Number(mid[0]) + (Math.random() - 0.5) * 0.05;
        lat = Number(mid[1]) + (Math.random() - 0.5) * 0.05;
      }
      this.form.extraPoints = this.form.extraPoints || [];
      this.form.extraPoints.push({
        id: -(Date.now() % 1000000),
        routeId: this.form.id,
        pointType: type,
        pointTypeText: type === 2 ? '豁免点' : '途经点',
        name: type === 2 ? '新豁免点' : '新途经点',
        category: 'CUSTOM',
        lng: Number(lng.toFixed(7)),
        lat: Number(lat.toFixed(7)),
        radiusM: type === 2 ? 200 : 0,
        seq: 0,
        remark: ''
      });
      this.redrawExtraPoints();
    },
    removeExtraPoint(idx) {
      const map = this.$refs.routeMap;
      if (map) {
        map.removeMarkerById('ep_' + idx);
        map.removeCircleById('ep_circle_' + idx);
      }
      this.form.extraPoints.splice(idx, 1);
      this.redrawExtraPoints();
    },
    // ========== 保存 ==========
    validate() {
      if (!this.form.name || !this.form.name.trim()) {
        this.$message.warning('请填写线路名称'); return false;
      }
      if (!this.form.geom || this.form.geom.length < 2) {
        this.$message.warning('请先查询车辆轨迹并生成基准线'); return false;
      }
      return true;
    },
    handleSave() {
      if (!this.validate()) return;
      this.cancelPickPoint();
      const g = this.form.geom || [];

      // 组装线路点：起点(0) + 中间点(2) + 终点(1) + 附加点(8)
      const AddPointData = [];
      // g.forEach(([lng, lat], i) => {
      //   AddPointData.push({
      //     WayPointID: 0,
      //     WayPointName: '',
      //     PointNo: i + 1,
      //     PointType: i === 0 ? 0 : (i === g.length - 1 ? 1 : 2),
      //     Longitude: lng,
      //     Latitude: lat,
      //     Remark: '',
      //     RangeRadius: 0
      //   });
      // });
      (this.form.extraPoints || []).forEach((p, i) => {
        AddPointData.push({
          WayPointID: p.id || 0,
          WayPointName: p.name || '',
          PointNo: g.length + i + 1,
          PointType: 8,
          Longitude: p.lng,
          Latitude: p.lat,
          Remark: p.remark || '',
          RangeRadius: p.radiusM || 0
        });
      });

      const timeRange = this.trackQuery.timeRange || [];
      const payload = {
        RouteID: this.form.id || -1,          // 主键，新建为-1
        RouteName: this.form.name,            // 线路名称
        RouteNo: this.form.code || '',        // 线路编号
        RouteStatus: this.form.status,        // 状态：1有效 0无效
        VehicleID: Number(this.form.sourceVehicleId) || 0, // 来源车辆ID
        EffStartTime: timeRange[0] || '',     // 轨迹线路开始时间
        EffEndTime: timeRange[1] || '',       // 轨迹线路结束时间
        Remark: this.form.remark || '',       // 线路备注
        AddPointData                          // 线路的点
      };

      this.saving = true;
      this.$api.SavePLRouteInfo(payload).then(res => {
        this.saving = false;
        if (res.code === 200) {
          this.$message.success(this.form.id ? '保存成功' : '创建成功');
          this.$emit('saved', res.data);
        }
      }).catch(() => { this.saving = false; });
    }
  }
};
</script>

<style scoped>
.route-edit-dialog ::v-deep .el-dialog__body { padding: 14px 20px 0; }
.edit-body { min-height: 580px; }
.top-info-bar {
  display: flex; justify-content: space-between; align-items: center;
  padding: 8px 10px; background: #f5f7fa; border-radius: 6px; margin-bottom: 10px;
}
.metrics { display: flex; gap: 18px; flex-shrink: 0; }
.metric { display: flex; flex-direction: column; align-items: center; min-width: 78px; }
.m-label { color: #909399; font-size: 12px; margin-bottom: 2px; }
.m-value { color: #303133; font-weight: 600; font-size: 15px; }

.track-query-bar {
  padding: 10px 14px; background: #ecf5ff; border-radius: 6px; margin-bottom: 10px;
  display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px;
}
.source-info { font-size: 12px; color: #409EFF; }
.source-info b { color: #303133; }

.main-split { display: flex; gap: 12px; min-height: 480px; }
.left-panel {
  width: 400px; flex-shrink: 0;
  display: flex; flex-direction: column; gap: 10px;
  overflow-y: auto; max-height: calc(100vh - 340px); padding-right: 6px;
}
.panel-section {
  background: #fafbfc; border: 1px solid #ebeef5; border-radius: 6px; padding: 10px 12px;
}
.panel-section.flex-grow { flex: 1; min-height: 180px; display: flex; flex-direction: column; }
.section-title {
  display: flex; align-items: center; justify-content: space-between;
  font-weight: 600; font-size: 13px; color: #303133;
  margin-bottom: 10px; padding-bottom: 6px; border-bottom: 1px dashed #ebeef5;
}
.section-title i { margin-right: 4px; color: #409EFF; }
.badge {
  display: inline-block; min-width: 20px; padding: 0 6px; height: 18px; line-height: 18px;
  background: #ecf5ff; color: #409EFF; border-radius: 9px; text-align: center; font-size: 12px;
  font-weight: normal; margin-left: 6px;
}
.section-actions { display: flex; gap: 4px; flex-wrap: wrap; }
.extra-points-list { flex: 1; overflow-y: auto; padding-right: 4px; }
.empty-tip { color: #c0c4cc; font-size: 12px; text-align: center; padding: 28px 0; }
.ep-item {
  display: flex; align-items: flex-start; gap: 8px; padding: 8px;
  background: #fff; border-radius: 4px; border: 1px solid #ebeef5; margin-bottom: 8px;
}
.ep-icon { margin-top: 4px; font-size: 16px; flex-shrink: 0; }
.ep-main { flex: 1; min-width: 0; }
.ep-name { font-weight: 600; color: #303133; margin-bottom: 2px; word-break: break-all; }
.ep-meta { font-size: 12px; color: #909399; margin-bottom: 4px; display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
.ep-type-tag { padding: 0 6px; border-radius: 3px; font-size: 12px; }
.ep-type-2 .ep-type-tag { background: #fdf6ec; color: #E6A23C; }
.ep-type-1 .ep-type-tag { background: #f4f4f5; color: #909399; }
.ep-radius { color: #E6A23C; }
.ep-coord { color: #606266; font-family: Consolas, monospace; }
.ep-form { margin-top: 6px; }
.ep-form .el-form-item { margin: 2px 10px 2px 0; }

.right-map {
  flex: 1; border: 1px solid #ebeef5; border-radius: 6px; overflow: hidden;
  display: flex; flex-direction: column; min-width: 0; position: relative;
}
.map-toolbar {
  display: flex; align-items: center; padding: 8px 12px;
  background: #f5f7fa; border-bottom: 1px solid #ebeef5; flex-shrink: 0; gap: 4px;
}
.pick-hint {
  color: #E6A23C; font-size: 12px; font-weight: 500;
  animation: blink 1s infinite;
}
@keyframes blink { 50% { opacity: 0.5; } }
.map-container { flex: 1; min-height: 460px; }
.map-legend {
  position: absolute; left: 12px; bottom: 12px;
  background: rgba(255,255,255,0.95); border: 1px solid #ebeef5; border-radius: 4px;
  padding: 8px 10px; font-size: 12px; color: #606266;
  display: grid; grid-template-columns: auto auto; gap: 4px 14px; z-index: 10;
}
.legend-item { display: flex; align-items: center; gap: 6px; }
.lg { display: inline-block; }
.lg.line { width: 20px; height: 3px; border-radius: 2px; }
.lg.line.route-line { background: #409EFF; }
.lg.line.original-line { background: #C0C4CC; }
.lg.dot { width: 10px; height: 10px; border-radius: 50%; border: 1.5px solid #fff; box-shadow: 0 0 0 1px rgba(0,0,0,0.1); }
.lg.dot.exempt-dot { background: #E6A23C; }
.lg.dot.waypoint-dot { background: #909399; }
</style>
